export default __webpack_public_path__ + "static/media/iconLinkVisualizar.368eac51.svg";